<div>
  <option-picker
    [initOption$]="initOption$"
    [label]="optionsLabel"
    [options]="options"
    [prefix]="optionsPrefix"
    (select)="onSelectCurrency($event)"
  ></option-picker>
</div>
